import { useEffect, useState } from "react";
import { PatientContext } from "./PatientContext";
import { FormatDate } from "../../../utilities/FormatDate";
import LocalStorage from "../../../utilities/Storage";


export const PatientProvider = ({ children }) => {

    const [patients, setPatients] = useState(() => {
        const savedPatients = LocalStorage.getItem('patients');
        return savedPatients ? JSON.parse(savedPatients) : []
    });

    const [showDetails, setShowDetails] = useState(() => {
        const savedShowDetails = LocalStorage.getItem('show-details');
        return savedShowDetails === true 
    });

    const [showGraph, setShowGraph] = useState(() => {
        const savedShowGraph = LocalStorage.getItem('show-graph');
        return savedShowGraph === true 
    });

    const [showFavorites, setShowFavorites] = useState(() => {
        const savedShowFavorites = LocalStorage.getItem('show-favorites');
        return savedShowFavorites === true 
    });

    useEffect(() => {
        LocalStorage.setItem('patients', JSON.stringify(patients))
    }, [patients]);

    useEffect(() => {
        LocalStorage.setItem('show-details', JSON.stringify(showDetails));
        LocalStorage.setItem('show-graph', JSON.stringify(showGraph));
        LocalStorage.setItem('show-favorites', JSON.stringify(showFavorites));
    }, [showDetails, showGraph, showFavorites])
    


    const initPatientList = (patient) => {
        setPatients(() => [{
            id: patient.patient_id,
            patient: patient,
            currentFeedingTimestamp: patient.feedings[0].timestamp
        }]);
    }

    const addPatient = (newPatient) => {
        setPatients((prev) => [...prev, {
            id: newPatient.patient_id,
            patient: newPatient,
            currentFeedingTimestamp: newPatient.feedings[0].timestamp
        }]);
        // printCurrentList();
    }

    const removePatient = (patientId) => {
        setPatients((prev) => prev.filter((patient) => patient.id !== patientId));
        // printCurrentList()
    }

    // Function to set the current feeding for a specific patient
    const setCurrentFeeding = (patientId, feedingTimestamp) => {
        setPatients((prev) =>
            prev.map((patient) =>
                patient.id === patientId ? { ...patient, currentFeedingTimestamp: feedingTimestamp } : patient
            )
        );
        // printCurrentList()
    };

    const getCurrentFeeding = (patientId) => {
        //printCurrentList()
        return patients.find((patient) => patient.id === patientId)?.currentFeedingTimestamp
    }

    const getCurrentFeedingWithoutPatientId = () => {
        //printCurrentList()
        return patients[0].currentFeedingTimestamp
    }

    const printCurrentList = () => {
        //console.log(`Patient List: ${patients.length} patients`);
        patients.forEach((patient) => console.log({ ...patient, current: FormatDate(patient.currentFeedingTimestamp) }));
    }

    const changeShowDetails = () => {
        setShowDetails(!showDetails);
    }
    
    const changeShowGraph = () => {
        setShowGraph(!showGraph);
    }
    
    const changeShowFavorites = () => {
        setShowFavorites(!showFavorites);
    }

    return (
        <PatientContext.Provider
            value={{
                patients,
                showDetails,
                showGraph,
                showFavorites,
                initPatientList,
                addPatient,
                removePatient,
                setCurrentFeeding,
                getCurrentFeeding,
                getCurrentFeedingWithoutPatientId,
                changeShowDetails,
                changeShowGraph,
                changeShowFavorites
            }}>
            {children}
        </PatientContext.Provider>
    );
}